/**
 * Access token (JWT) içeriğini okur. İmza doğrulaması yapılmaz; yalnızca ekranda
 * neyin gösterileceğine karar vermek içindir, yetki kontrolü backend'dedir.
 */
export function decodeTokenPayload(token?: string | null): Record<string, any> | null {
  if (!token) return null
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

/** Token'daki roles claim'i Spring yetkileri olarak gelir: ROLE_ADMIN gibi */
export function hasRole(token: string | null | undefined, role: string): boolean {
  const roles: unknown = decodeTokenPayload(token)?.roles
  return Array.isArray(roles) && roles.includes(`ROLE_${role}`)
}

export const ADMIN_ROLE = 'ADMIN'
/** İK dashboard'unu gören rol */
export const HR_SPECIAL_ROLE = 'HR_SPECIAL'
